import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useImportFixtureRoster = (entityId: string, fixtureId: string) => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (fileName: string) =>
      await request(`${sport}/o/${organizationId}/fixtures/${fixtureId}/entities/${entityId}/roster/import`, {
        method: "POST",
        body: { fileName },
      }),
  });
};
